import requiredLicenses from './requiredLicenseTypes';
import notRequiredLicenses from './noLicenseRequiredLicenseTypes';

export default {
  licenses: [...requiredLicenses.licenses, ...notRequiredLicenses.licenses]
};
